export class CatalogCheckNameRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "catalogId",
            "baseName": "catalogId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "databaseName",
            "baseName": "databaseName",
            "type": "string",
            "format": ""
        },
        {
            "name": "tableName",
            "baseName": "tableName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CatalogCheckNameRequest.attributeTypeMap;
    }
    constructor() {
    }
}
